import { useQuery as n } from "@tanstack/react-query";
const s = () => n({
  queryKey: ["stations"],
  queryFn: async () => {
    const e = `${__PATH_PREFIX__}/stations-store.json`;
    return fetch(e).then((t) => t.json()).then((t) => t.data ? t.data : []);
  },
  enabled: !0,
  retry: !1,
  staleTime: 1 / 0
});
export {
  s as useStationsQuery
};
